import React from 'react'
import t from '~t'
import { Link } from 'react-router-dom'

import { Button, HeaderTitle as Title, Header, Icon } from '~ui';

export default function ExtensionTabsHeader() {
    return (
        <Header data-no-shadow data-static>
            <Button variant='ghost' 
                as={Link}
                to='/'
                title={t.s('back')}>
                <Icon name='back' />
            </Button>

            <Title>
                {t.s('saveTabs')}
            </Title>
        </Header>
    )
}